module.exports = __webpack_public_path__ + "web/img/chapter-60.895396eb.png";